import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { get } from 'lodash-es'
import { ErrorFallback } from '@ow/comps'
import { useProjectStore } from '@vt/hooks'
import { CreateOperateElement } from '../../../menu/hooks/operate'
import ElementRender from './ElementRender'

const RenderNavMenu = function ({ layouts }) {
  const elements = get(layouts, 'elements', []).filter((v) => v)

  const customCompsMap = useProjectStore((state) => state.customCompsMap)

  const { ExtTriggersComponent } = customCompsMap || {}
  if (
    ((!elements || !elements.length) && !ExtTriggersComponent) ||
    (elements &&
      elements[0] &&
      get(elements[0], 'rightElements', []).length === 0)
  ) {
    return null
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <CreateOperateElement>
        {elements.length > 0 && (
          <div
            style={{ minHeight: '56px' }}
            className="flex flex-row items-center"
          >
            {elements.map((element, index) => {
              return (
                <ElementRender
                  key={`${element.type}-${index}`}
                  layouts={element}
                />
              )
            })}
            {ExtTriggersComponent && <ExtTriggersComponent />}
          </div>
        )}
      </CreateOperateElement>
    </ErrorBoundary>
  )
}

export default RenderNavMenu
